.<template>
  <div :class="$setClasses">
    <p v-if="!meeting || !paramsMeeting"
       class="u-margin-top-0">
      {{ $t("meeting.subtitle", { duration }) }}
    </p>
    <template v-else>
      <template v-if="paramsMeeting.start && content.date">
        <p :class="$vClass('meeting')">{{ content.date }}</p>
      </template>
      <template v-if="meeting.operator">
        <div class="u-display-flex u-ai-center u-jc-center u-padding-bottom-small">
          <nxt-tasks-avatar :user="meeting.operator" not-tooltip simple></nxt-tasks-avatar>
          <span class="u-margin-left-xsmall">
          {{ meeting.operator.first_name }} {{ meeting.operator.last_name }}
        </span>
        </div>
      </template>
      <div :class="$vClass('button-wrapper')">
        <nxt-core-btn
          v-loading="isDataSaving"
          :aria-label="$t('meeting.booking')"
          :class="[$vPrefix('btn'), $vPrefix('btn--meeting')]"
          :disabled="isMeetingLoading || isDataSaving"
          @click="handlerPostMeeting(paramsMeeting)"
        >
          <span :class="buttonLabel">{{ $t("meeting.booking") }}</span>
          <span
            v-if="isMeetingLoading"
            :class="[$vPrefix('btn--meeting__spinner'), $vPrefix('btn__spinner')]"
          >
            <font-awesome-icon :class="$vPrefix('spinner')" :icon="['fa', 'circle-notch']" />
          </span>
        </nxt-core-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapActions, mapWritableState, mapState } from "pinia";
import { useMeetingStore } from "@nextories/vue-core-components/src/store/meetingStore.ts";
import { useAuthStore } from "@nextories/vue-tasks/src/store/authStore.ts";
import {useProjectsStore} from "@nextories/vue-tasks/src/store/projectsStore.ts";
import {useEmailStore} from "@nextories/vue-tasks/src/store/emailStore.ts";

export default {
  name: "MeetingDisplay",
  nameClassStyle: "meeting-display",
  props: {
    meeting: {
      type: Object,
    },
    duration: Number,
    granularity: Number,
    isMeetingLoading: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState(useMeetingStore, ["isDataSaving", "savedApiResponse"]),
    ...mapState(useAuthStore, ['currentUser']),
    ...mapWritableState(useMeetingStore, ["lock"]),
    ...mapWritableState(useProjectsStore, ["project"]),
    buttonLabel() {
      return {
        [this.$vPrefix("btn__label--loading")]: this.isMeetingLoading,
      };
    },
    content() {
      return this.meeting.content;
    },
    paramsMeeting() {
      return this.meeting.params;
    },
  },
  methods: {
    ...mapActions(useMeetingStore, ["postMeeting", "setSavedApiResponse"]),
    ...mapActions(useProjectsStore, ["setProject", "saveMeetingInfos"]),
    ...mapActions(useEmailStore, ["getListTemplates"]),
    async handlerPostMeeting(meeting) {
      try {
        const data = {
          ...meeting,
          granularity: this.granularity,
          user_id: this.currentUser.id,
        };
        await this.postMeeting(data);
        this.lock = {};
        this.setSavedApiResponse({
          api_meeting: {
            ...this.savedApiResponse.api_meeting,
            ...data,
          },
        });
        this.setProject({
          ...this.project,
          meeting: {
            ...this.project.meeting,
            ...data,
            date_start: data.start,
            duration_minutes: data.duration,
          },
          visit_type: data.visit_type,
        }, this.project.tasks);
        this.saveMeetingInfos();
        await this.getListTemplates({
          mainActions: true,
          token: window.connector.projectToken,
        });
        await this.$helpers['event-bus'].$emit('refresh:tabs');
        await this.$helpers["event-bus"].$emit("validateForm", {
          action: "submitForm",
        });
      } catch (error) {
        this.$message({
          type: "error",
          message: this.$t("base.messageError.slotAvailable"),
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.#{$prefixName}meeting-display {
  border-radius: var(--nxt-border-radius-base);
  padding: var(--nxt-space-small);
  margin: var(--nxt-space-small) auto;
  max-width: 420px;
  text-align: center;
  background-color: #f4f5f7;

  &__meeting {
    text-align: center;
    align-items: center;
    margin: {
      top: 0;
      bottom: var(--nxt-space-small);
    }
    font-size: var(--nxt-font-size-medium);
    font-weight: var(--nxt-font-weight-bold);
  }

  &__button__wrapper {
    text-align: center;
  }
}
</style>
